import { useState } from "react";
import "./ProductImageGallery.css"; // CSS khusus jika perlu

export default function ProductImageGallery({ photos = [] }) {
    const [activeIndex, setActiveIndex] = useState(0);

    if (photos.length === 0) return null;

    return (
        <div className="d-flex flex-row gap-4 product-image-gallery">
            {/* Thumbnail Side */}
            <div className="d-flex flex-column gap-2" style={{ maxHeight: 400, overflowY: "auto" }}>
                {photos.map((photo, index) => (
                    <img
                        key={index}
                        src={photo}
                        alt={`Thumbnail ${index}`}
                        onClick={() => setActiveIndex(index)}
                        style={{
                            width: 80,
                            height: 80,
                            objectFit: "cover",
                            cursor: "pointer",
                            border: index === activeIndex ? "2px solid #007bff" : "1px solid #ccc",
                            borderRadius: 4,
                        }}
                    />
                ))}
            </div>

            {/* Preview Side */}
            <div className="flex-grow-1 d-flex align-items-center justify-content-center" style={{ minHeight: 400 }}>
                <img
                    src={photos[activeIndex]}
                    alt={`Preview ${activeIndex}`}
                    className="img-fluid"
                    style={{ maxHeight: 400, objectFit: "contain" }}
                />
            </div>
        </div>
    );
}
